export const environment = {
  production: true,
  frontend_url: 'https://qlm.pro',
  backend_url: 'https://api.qlm.pro',
  backend_socket: 'wss://api.qlm.pro',
  // Vercel proxy for Spaces files (apps/edu-files-proxy). Replace with the deployed
  // proxy domain once it is live so files load in regions that block Spaces.
  filesProxyUrl: 'https://cdn.qlm.pro',
  assets: {
    logo: "assets/QLM.png",
    favIcon: "favicon-qlm.ico"
  },
  org: "QLM",
  csteamOrganizationId: "c7e6721e-34e4-42da-91a6-fe61e842c830",
  // ICTeam org id on the Papyrus backend. The translator guard only sees org membership, so access here
  // is org-level; the single-subject restriction is enforced by the navbar button in edu-angular.
  // TODO: replace with the ICTeam organization id on the Papyrus backend.
  icteamOrganizationId: "13e81ca6-e30e-4b47-aaea-5432c435d440",
  "domain": ".qlm.pro",
  iosLink: "",
  androidLink: "",
  firebase: {
    apiKey: "AIzaSyCYqchHrDNS-2BDO8IYwYVMvA9xrsIFB6g",
    authDomain: "edu-mono-csteam.firebaseapp.com",
    projectId: "edu-mono-csteam",
    storageBucket: "edu-mono-csteam.firebasestorage.app",
    messagingSenderId: "1081248593964",
    appId: "1:1081248593964:web:97384bf0bffe78ccedf989",
    measurementId: "G-4NCC3EYPK0",
    vapidKey: "BIVKJnOi5oV61s_HTxtI_ffC4t9DAppshhfgm68fSX0eIjcd7rstxoEwxSkiLnYjvq-bEldkUjKDeQn2zhY3U4Q"
  },
  // QLM OIDC login -- QLM is the intended first tenant to switch, but this stays
  // disabled until its backend has the OIDC provider configured (OIDC_JWKS/OIDC_ISSUER,
  // migration, client row) and the flow has been verified there.
  oidc: {
    issuer: 'https://api.qlm.pro/oidc',
    clientId: 'edu-translator',
    providerName: 'QLM',
    redirectUri: 'https://translator.qlm.pro/auth/callback',
    loginUrl: 'https://api.qlm.pro/oidc/auth',
    tokenEndpoint: 'https://api.qlm.pro/oidc/token',
    scope: 'openid email translator',
  },
};
